module.exports = __webpack_public_path__ + "img/idcard_example_1.f34fcaa9.png";